import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import {Helmet} from "react-helmet";
import {Link} from 'react-router-dom';
import {Breadcrumb,} from 'semantic-ui-react';

import CustomDivider from '../../components/extras/CustomDivider';
import CloseBoxDetail from "../../components/open_box/CloseBoxDetail";

class CloseBox extends Component {
    render() {
        return (
            <div>
                <Helmet>
                    <title>Quipuu - Vender</title>
                </Helmet>
                <Breadcrumb>
                    <Breadcrumb.Section as={Link} to='/sale'>Vender</Breadcrumb.Section>
                    <Breadcrumb.Divider/>
                    <Breadcrumb.Section active>Cierre de Caja</Breadcrumb.Section>
                </Breadcrumb>
                <CustomDivider/>
                <CloseBoxDetail is_current/>
            </div>
        );
    }
}

export default withRouter(CloseBox);



// WEBPACK FOOTER //
// ./src/containers/sale/CloseBox.js